export default __webpack_public_path__ + "static/media/f-ads.5103ffe4.svg";